import { Directive, ElementRef, inject, input, OnInit } from '@angular/core';

@Directive({
    selector: '[stbyDynamicAttributes]',
})
export class DynamicAttributesDirective implements OnInit {
    element = inject(ElementRef);

    readonly stbyDynamicAttributes = input<{
        [key: string]: string | number;
    }>();

    ngOnInit() {
        for (const key in this.stbyDynamicAttributes()) {
            const stbyDynamicAttributes = this.stbyDynamicAttributes();
            if (stbyDynamicAttributes.hasOwnProperty(key)) {
                this.element.nativeElement.setAttribute(key, stbyDynamicAttributes[key] + '');
            }
        }
    }
}
